import { c as _c } from "react/compiler-runtime";
import { ComboboxButton, ComboboxOption, ComboboxOptions, Field } from '@headlessui/react';
import { ArrowButton, CloseButton, ComboboxSinge, FieldErrorAndDescription, FieldLabel, FormSelectDataType, FormSelectIdType, FormSelectInput, FormSelectProps, getSelectedData, useFilteredData } from '@systemeio/ui';
import { useEffect, useState } from 'react';
import { ListOptionsWithGroups } from 'shared/components/form-select/components/list-options-with-groups';
import { twMerge } from 'tailwind-merge';
export interface FormSelectDataWithGroupType<T extends FormSelectIdType = FormSelectIdType, G extends string = string> extends FormSelectDataType<T> {
  group: G;
}
interface FormSelectWithGroupsProps<T extends FormSelectIdType> extends Omit<FormSelectProps<T>, 'data'> {
  groups: {
    id: string;
    caption: string;
  }[];
  data: FormSelectDataWithGroupType<T>[] | undefined;
}
export function FormSelectWithGroups(t0) {
  const $ = _c(77);
  let arrowButtonClassName;
  let className;
  let closeButtonClassName;
  let containerClassName;
  let data;
  let dataTest;
  let description;
  let disabled;
  let error;
  let fieldClassName;
  let groups;
  let inputRef;
  let inputWrapperClassName;
  let isPreFetching;
  let label;
  let labelClassName;
  let onChange;
  let onClose;
  let onOpen;
  let optionsProps;
  let placeholder;
  let required;
  let staticData;
  let value;
  let withoutCloseIcon;
  let wrapperProps;
  if ($[0] !== t0) {
    const {
      label: t1,
      data: t2,
      staticData: t3,
      onChange: t4,
      labelClassName: t5,
      value: t6,
      isPreFetching: t7,
      placeholder: t8,
      error: t9,
      required: t10,
      description: t11,
      className: t12,
      containerClassName: t13,
      closeButtonClassName: t14,
      arrowButtonClassName: t15,
      fieldClassName: t16,
      disabled: t17,
      withoutCloseIcon: t18,
      onOpen: t19,
      onClose: t20,
      dataTest: t21,
      wrapperProps: t22,
      loaderClassName,
      loaderWrapperClassName,
      inputWrapperClassName: t23,
      inputRef: t24,
      groups: t25,
      ...t26
    } = t0;
    label = t1;
    data = t2;
    staticData = t3;
    onChange = t4;
    labelClassName = t5;
    value = t6;
    isPreFetching = t7;
    placeholder = t8;
    error = t9;
    required = t10;
    description = t11;
    className = t12;
    containerClassName = t13;
    closeButtonClassName = t14;
    arrowButtonClassName = t15;
    fieldClassName = t16;
    disabled = t17;
    withoutCloseIcon = t18;
    onOpen = t19;
    onClose = t20;
    dataTest = t21;
    wrapperProps = t22;
    inputWrapperClassName = t23;
    inputRef = t24;
    groups = t25;
    optionsProps = t26;
    $[0] = t0;
    $[1] = arrowButtonClassName;
    $[2] = className;
    $[3] = closeButtonClassName;
    $[4] = containerClassName;
    $[5] = data;
    $[6] = dataTest;
    $[7] = description;
    $[8] = disabled;
    $[9] = error;
    $[10] = fieldClassName;
    $[11] = groups;
    $[12] = inputRef;
    $[13] = inputWrapperClassName;
    $[14] = isPreFetching;
    $[15] = label;
    $[16] = labelClassName;
    $[17] = onChange;
    $[18] = onClose;
    $[19] = onOpen;
    $[20] = optionsProps;
    $[21] = placeholder;
    $[22] = required;
    $[23] = staticData;
    $[24] = value;
    $[25] = withoutCloseIcon;
    $[26] = wrapperProps;
  } else {
    arrowButtonClassName = $[1];
    className = $[2];
    closeButtonClassName = $[3];
    containerClassName = $[4];
    data = $[5];
    dataTest = $[6];
    description = $[7];
    disabled = $[8];
    error = $[9];
    fieldClassName = $[10];
    groups = $[11];
    inputRef = $[12];
    inputWrapperClassName = $[13];
    isPreFetching = $[14];
    label = $[15];
    labelClassName = $[16];
    onChange = $[17];
    onClose = $[18];
    onOpen = $[19];
    optionsProps = $[20];
    placeholder = $[21];
    required = $[22];
    staticData = $[23];
    value = $[24];
    withoutCloseIcon = $[25];
    wrapperProps = $[26];
  }
  const [opened, setOpened] = useState(false);
  let t1;
  if ($[27] !== onOpen || $[28] !== opened) {
    t1 = () => {
      if (opened && onOpen) {
        onOpen();
        setOpened(false);
      }
    };
    $[27] = onOpen;
    $[28] = opened;
    $[29] = t1;
  } else {
    t1 = $[29];
  }
  let t2;
  if ($[30] !== opened) {
    t2 = [opened];
    $[30] = opened;
    $[31] = t2;
  } else {
    t2 = $[31];
  }
  useEffect(t1, t2);
  let t3;
  if ($[32] !== data || $[33] !== staticData || $[34] !== value) {
    t3 = getSelectedData(value, data ?? staticData) ?? null;
    $[32] = data;
    $[33] = staticData;
    $[34] = value;
    $[35] = t3;
  } else {
    t3 = $[35];
  }
  const selectedData = t3;
  const {
    filteredData,
    setQuery
  } = useFilteredData(data);
  const hasValue = value !== undefined;
  const noData = !data && !staticData;
  const onlyValue = hasValue && noData;
  const isDisabled = disabled || isPreFetching || onlyValue;
  const showCloseButton = hasValue && !withoutCloseIcon && !isDisabled;
  let t4;
  if ($[36] !== containerClassName) {
    t4 = twMerge("relative flex flex-col gap-1", containerClassName);
    $[36] = containerClassName;
    $[37] = t4;
  } else {
    t4 = $[37];
  }
  let t5;
  if ($[38] !== onClose || $[39] !== setQuery) {
    t5 = () => {
      setQuery("");
      onClose?.();
    };
    $[38] = onClose;
    $[39] = setQuery;
    $[40] = t5;
  } else {
    t5 = $[40];
  }
  let t6;
  if ($[41] !== arrowButtonClassName || $[42] !== className || $[43] !== closeButtonClassName || $[44] !== dataTest || $[45] !== error || $[46] !== fieldClassName || $[47] !== filteredData || $[48] !== groups || $[49] !== inputRef || $[50] !== inputWrapperClassName || $[51] !== isDisabled || $[52] !== isPreFetching || $[53] !== label || $[54] !== labelClassName || $[55] !== onChange || $[56] !== optionsProps || $[57] !== placeholder || $[58] !== required || $[59] !== selectedData?.caption || $[60] !== setQuery || $[61] !== showCloseButton || $[62] !== wrapperProps) {
    t6 = open => <><Field className={twMerge("relative flex flex-col gap-1", fieldClassName)}><FieldLabel wrapperAs="label" wrapperProps={wrapperProps} label={label} required={required} labelClassName={twMerge("text-sm font-medium", labelClassName)} /><ComboboxButton as="button" className={twMerge("relative", inputWrapperClassName)}><FormSelectInput dataTest={dataTest} inputRef={inputRef} isDisabled={isDisabled} hasError={!!error} open={open} className={className} placeholder={placeholder} selectedCaption={selectedData?.caption ?? ""} isPreFetching={isPreFetching} onFocus={() => setOpened(true)} onChange={value_0 => {
            setOpened(true);
            setQuery(value_0);
          }} /><ArrowButton isDisabled={isDisabled} arrowButtonClassName={twMerge("absolute inset-y-0 right-4 h-[46px] sm:h-[42px]", arrowButtonClassName)} open={open} /></ComboboxButton>{showCloseButton && <CloseButton isDisabled={isDisabled} closeButtonClassName={twMerge("absolute bottom-0 right-10 h-[46px] sm:h-[42px]", closeButtonClassName)} onClick={() => onChange(undefined)} />}</Field><ListOptionsWithGroups asOptions={ComboboxOptions} asOption={ComboboxOption} data={filteredData} groups={groups} {...optionsProps} /></>;
    $[41] = arrowButtonClassName;
    $[42] = className;
    $[43] = closeButtonClassName;
    $[44] = dataTest;
    $[45] = error;
    $[46] = fieldClassName;
    $[47] = filteredData;
    $[48] = groups;
    $[49] = inputRef;
    $[50] = inputWrapperClassName;
    $[51] = isDisabled;
    $[52] = isPreFetching;
    $[53] = label;
    $[54] = labelClassName;
    $[55] = onChange;
    $[56] = optionsProps;
    $[57] = placeholder;
    $[58] = required;
    $[59] = selectedData?.caption;
    $[60] = setQuery;
    $[61] = showCloseButton;
    $[62] = wrapperProps;
    $[63] = t6;
  } else {
    t6 = $[63];
  }
  let t7;
  if ($[64] !== isDisabled || $[65] !== onChange || $[66] !== selectedData || $[67] !== t5 || $[68] !== t6) {
    t7 = <ComboboxSinge selectedData={selectedData} onChange={onChange} disabled={isDisabled} onClose={t5}>{t6}</ComboboxSinge>;
    $[64] = isDisabled;
    $[65] = onChange;
    $[66] = selectedData;
    $[67] = t5;
    $[68] = t6;
    $[69] = t7;
  } else {
    t7 = $[69];
  }
  let t8;
  if ($[70] !== description || $[71] !== error) {
    t8 = <FieldErrorAndDescription error={error} description={description} />;
    $[70] = description;
    $[71] = error;
    $[72] = t8;
  } else {
    t8 = $[72];
  }
  let t9;
  if ($[73] !== t4 || $[74] !== t7 || $[75] !== t8) {
    t9 = <div className={t4}>{t7}{t8}</div>;
    $[73] = t4;
    $[74] = t7;
    $[75] = t8;
    $[76] = t9;
  } else {
    t9 = $[76];
  }
  return t9;
}